export type PortalThemeFieldId = 'primary' | 'heroBackground' | 'buttonText' | 'text' | 'outlineButton' | 'background' | 'productTile' | 'border';
export type PortalThemeColors = Record<PortalThemeFieldId, string>;
export const portalThemeFields: {
  id: PortalThemeFieldId;
  label: string;
  help: string;
}[] = [{
  id: 'primary',
  label: 'Primary / button colour',
  help: 'Main brand fill for buttons and highlights'
}, {
  id: 'heroBackground',
  label: 'Hero background',
  help: 'The hero banner fill at the top of the portal'
}, {
  id: 'buttonText',
  label: 'Button text colour',
  help: 'Text on filled primary buttons only'
}, {
  id: 'text',
  label: 'Text colour',
  help: 'All page text except inside the hero, where text is fixed white'
}, {
  id: 'outlineButton',
  label: 'Outline button colour',
  help: 'Not currently connected to anything in the portal — pending a decision to wire it up or remove it'
}, {
  id: 'background',
  label: 'Background',
  help: 'The canvas behind the dashboard'
}, {
  id: 'productTile',
  label: 'Product tile background',
  help: 'The image backdrop behind each bottle'
}, {
  id: 'border',
  label: 'Border colour',
  help: 'Outline borders and card outlines across the portal'
}];
export const defaultPortalThemeColors: PortalThemeColors = {
  primary: '#722F37',
  heroBackground: '#8F3D47',
  buttonText: '#FFFFFF',
  text: '#0F172A',
  outlineButton: '#CBD5E1',
  background: '#F8F5F2',
  productTile: '#EFE7E1',
  border: '#DED5CE'
};
/** Which subscription state the colours being edited apply to. */
export type PortalThemeState = 'active' | 'paused';
export const portalThemeStates: {
  id: PortalThemeState;
  label: string;
}[] = [{
  id: 'active',
  label: 'Active'
}, {
  id: 'paused',
  label: 'Paused'
}];
/** Muted palette shown while a member's subscription is paused. */
export const defaultPausedPortalThemeColors: PortalThemeColors = {
  primary: '#8A7F7F',
  heroBackground: '#5B5153',
  buttonText: '#FFFFFF',
  text: '#334155',
  outlineButton: '#CBD5E1',
  background: '#F4F2F1',
  productTile: '#E7E3E1',
  border: '#D8D3D0'
};
export type PortalPreviewPageId = 'collection' | 'upcoming' | 'rewards' | 'past' | 'preferences';
export const portalPreviewPages: {
  id: PortalPreviewPageId;
  label: string;
}[] = [{
  id: 'collection',
  label: 'Your Collection'
}, {
  id: 'upcoming',
  label: 'Upcoming Deliveries'
}, {
  id: 'rewards',
  label: 'Rewards'
}, {
  id: 'past',
  label: 'Past Deliveries'
}, {
  id: 'preferences',
  label: 'Preferences'
}];
export type PortalPreviewMode = 'subscriber' | 'loyalty';
export const portalPreviewModes: {
  id: PortalPreviewMode;
  label: string;
}[] = [{
  id: 'subscriber',
  label: 'Subscriber'
}, {
  id: 'loyalty',
  label: 'Loyalty only'
}];
export type PortalLoyaltyPageId = 'rewards' | 'orders' | 'support' | 'account';
export const portalLoyaltyPages: {
  id: PortalLoyaltyPageId;
  label: string;
}[] = [{
  id: 'rewards',
  label: 'Rewards'
}, {
  id: 'orders',
  label: 'Orders'
}, {
  id: 'support',
  label: 'Support'
}, {
  id: 'account',
  label: 'Account'
}];
export type PortalPreviewModalId = 'none' | 'membership' | 'reschedule' | 'pause' | 'swap' | 'skip' | 'shipNow' | 'cancellation';
export const portalPreviewModals: {
  id: PortalPreviewModalId;
  label: string;
}[] = [{
  id: 'none',
  label: 'None'
}, {
  id: 'membership',
  label: 'Adjust Membership'
}, {
  id: 'reschedule',
  label: 'Reschedule'
}, {
  id: 'pause',
  label: 'Pause'
}, {
  id: 'swap',
  label: 'Swap Product'
}, {
  id: 'skip',
  label: 'Skip Next Delivery'
}, {
  id: 'shipNow',
  label: 'Ship Now'
}, {
  id: 'cancellation',
  label: 'Cancellation'
}];
